"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShapeableFont = void 0;
exports.ShapeableFont = {
  Banner: "\uE900",
  Benefit: "\uE901",
  BenefitType: "\uE902",
  Block: "\uE904",
  BusinessModel: "\uE905",
  Challenge: "\uE906",
  Chapter: "\uE907",
  ChapterRole: "\uE908",
  CorporationSize: "\uE90a",
  Course: "\uE94d",
  DataSet: "\uE90b",
  Document: "\uE90c",
  DocumentType: "\uE90d",
  Economy: "\uE90e",
  Event: "\uE90f",
  ExpertiseLevel: "\uE910",
  Feed: "\uE911",
  FeedEntry: "\uE912",
  FileAsset: "\uE913",
  Podcast: "\uE946",
  FileType: "\uE914",
  PodcastType: "\uE914",
  Folder: "\uE915",
  ImpactResult: "\uE916",
  ImpactResultType: "\uE917",
  ImpactStory: "\uE918",
  Indicator: "\uE919",
  Industry: "\uE91a",
  InfluencingFactor: "\uE91b",
  KeyIssue: "\uE91c",
  PageLayout: "\uE91d",
  SliceLayout: "\uE91d",
  Lesson: "\uE94c",
  Link: "\uE91e",
  LinkType: "\uE91f",
  Location: "\uE922",
  MaturityStage: "\uE923",
  OfferingType: "\uE924",
  Organisation: "\uE925",
  OrganisationChapterRole: "\uE926",
  OrganisationPosition: "\uE927",
  OrganisationStatus: "\uE928",
  OrganisationTeamRole: "\uE929",
  OrganisationType: "\uE92a",
  Page: "\uE92b",
  Post: "\uE918",
  Slice: "\uE92c",
  Person: "\uE92d",
  Pillar: "\uE92e",
  Position: "\uE92f",
  Product: "\uE94b",
  Profile: "\uE930",
  Project: "\uE931",
  ProjectStatus: "\uE932",
  ProjectType: "\uE933",
  Quote: "\uE935",
  Role: "\uE936",
  Sdg: "\uE937",
  Session: "\uE94a",
  Skill: "\uE938",
  State: "\uE93a",
  Target: "\uE93c",
  TargetMarket: "\uE93d",
  Team: "\uE93e",
  TeamRole: "\uE93f",
  TeamType: "\uE940",
  Unit: "\uE942",
  User: "\uE943",
  UserPermission: "\uE944",
  UserRole: "\uE945",
  Video: "\uE946",
  Visibility: "\uE947",
  Workstream: "\uE948",
  WorkstreamType: "\uE949"
};